import axios from 'axios';
import { Country } from '../types/Country';

export const fetchCountriesService = async (): Promise<Country[]> => {
  const response = await axios.get<Country[]>('https://api.sampleapis.com/countries/countries');
  return response.data;
};
